import { Link } from '@remix-run/react';
import { IconTag } from '@tabler/icons-react';

import { useRoutePath } from '~/hooks/useRoutePath';
import { Brand } from '~/types/Brand';

interface BrandCardProps {
  brand: Brand;
}

const BrandCard = ({ brand }: BrandCardProps) => {
  const routePath = useRoutePath();

  return (
    <div className="brand-card">
      <Link to={routePath('brand', brand.slug)} className="brand-card__link" aria-label={brand.name} />
      {brand.imagePath ? (
        <img src={brand.imagePath} alt={brand.name} className="brand-card__image" loading="lazy" decoding="async" />
      ) : (
        <div className="brand-card__image brand-card__image--placeholder">
          <IconTag size={48} stroke={1.5} />
        </div>
      )}
      <h3 className="brand-card__name">{brand.name}</h3>
    </div>
  );
};

export default BrandCard;
